import "slick-carousel/slick/slick.min.js";  
import '/src/js/recentsearches.js'
import '/src/js/custom.js'
// Slick - Hero slider
$(document).ready(function(){
    var isIE = /MSIE|Trident/.test(window.navigator.userAgent);

    // Initiate Hero Slider using Slick plugin
    if (isIE) {
        if ($('.hero-slides').length !== 0) {
            $('.hero-slides').slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                autoplay: false,
                draggable: true,
                autoplaySpeed: 5000,
                prevArrow: $('.slick-prev'),
                nextArrow: $('.slick-next'),
            });
        }
    } else {
        if ($('.hero-slides').length !== 0) {
            $('.hero-slides').slick({
                dots: true,
                infinite: true,
                speed: 500,
                fade: true,
                cssEase: 'linear',
                autoplay: true,
                draggable: true,
                autoplaySpeed: 5000,
                prevArrow: $('.slick-prev'),
                nextArrow: $('.slick-next'),
            });
        }
    }

    // Dan - 06-09-2021
    // Weather widget was scrapped, decided not to remove code just incase.. The endpoint is still active, just these init scripts have been removed.
    
    // Weather Widget close
    //$('#weather-close').on('click', function () {
    //    $('#weather-widget').addClass('hidden');
    //});

    //weatherWidgetTrigger();

    //$('#allow-location').on('click', function () {
    //    weatherWidgetTrigger();
    //});
});

//// Geolocation for Weather Widget
function weatherWidgetTrigger() {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
            $.ajax({
                type: "POST",
                url: "/umbraco/Surface/Weather/CallWeatherApi",
                data: { 'lat': position.coords.latitude, 'lon': position.coords.longitude },
                dataType: "html",
                success: function (result) {
                    $('#weather-widget-content').html(result);
                }
            });
        }, function () {
            $('#weather-widget').remove();
        });
    }
}
